import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelect } from 'primeng/multiselect';
import CountryLanguageWriteDTO from '../../../../../../types/country-language/CountryLanguageWriteDTO';
import CountryWriteDTO from '../../../../../../types/country/CountryWriteDTO';
import Language from '../../../../../../types/language/Language';
import { CountryService } from '../../../../services/country.service';
import { LanguageService } from '../../../../services/language.service';

@Component({
    selector: 'app-create-country-dialog',
    templateUrl: './create-country-dialog.component.html',
    styleUrls: [ './create-country-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        MultiSelect,
    ]
})
export class CreateCountryDialogComponent implements OnInit {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() countryCreated: EventEmitter<CountryWriteDTO> = new EventEmitter<CountryWriteDTO>();

    constructor(
        private countryService: CountryService,
        private messageService: MessageService,
        private languageService: LanguageService
    ) {
    }

    public country: CountryWriteDTO = new CountryWriteDTO({});
    public availableLanguages: Language[] = [];
    public selectedLanguages: Language[] = [];

    public loading = false;
    public loadingLanguages = false;

    public ngOnInit() {
        this.loadLanguages();
    }

    get saveDisabled(): boolean {
        return !this.country.name;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public loadLanguages() {
        this.loadingLanguages = true;
        this.languageService
            .getAllLanguages()
            .then((languages) => {
                this.availableLanguages = languages;
            })
            .catch((error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            })
            .finally(() => {
                this.loadingLanguages = false;
            });
    }

    public saveCountry() {
        this.loading = true;

        // Map selected languages to CountryLanguageWriteDTO
        this.country.languages = this.selectedLanguages.map(
            (language) => new CountryLanguageWriteDTO({ languageId: language.id })
        );

        this.countryService
            .createCountry(this.country)
            .then(() => {
                this.countryCreated.emit(this.country);
                this.close();
            })
            .catch((error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            })
            .finally(() => {
                this.country = new CountryWriteDTO({});
                this.selectedLanguages = [];
                this.loading = false;
            });
    }
}
